import React from "react"

  const darkTheme = {
    back: "#171c28",
    title: "#fff",
    url: "#FFFF00"
  }
  
  const lightTheme = {
    back: "#fff",
    title: "#171c28",
    url: "#FF6600"
  }

 export const themes = {
    light: lightTheme,
    dark: darkTheme
  }


 export  const ThemeSwitcher = React.createContext(themes.light)